<template>
  <v-card :style="{ 'background-color': 'rgb(0,0,0,0.1)' }" dark>
    <v-card-text>
      <v-form>
        <v-text-field
          label="Login"
          name="login"
          prepend-icon="person"
          type="text"
          v-model="email"
        />
        <small class="ml-8 red--text" v-if="snackbar" style="font-size: 15px">
          Access Denied!
          {{ loginMsg }}
        </small>

        <v-text-field
          id="password"
          label="Password"
          name="password"
          prepend-icon="lock"
          type="password"
          v-model="password"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined dark @click.prevent="login" rounded class="ml-10 mb-8"
        >Login</v-btn
      ><v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "@/plugins/axios";
import HeaderAndFooter from "@/components/HeaderAndFooter";
import { mapGetters } from "vuex";
import io from "socket.io-client";

export default {
  computed: mapGetters(["getThemeColor", "getSocket", "getEndPoint"]),

  data() {
    return {
      email: "",
      password: "",
      snackbar: false,
      loginMsg: "",
    };
  },

  methods: {
    login() {
      axios
        .postData("/auth/login", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          if (response.status != 401) {
            this.snackbar = true;
            this.$store.commit("setAccessToken", response.token);
            this.$store.commit("setCurrentUser", response.user);
            this.$store.commit("setAuthenticated", true);

            // const socket = io(this.getEndPoint);
            // this.$store.commit("setSocket", socket);

            localStorage.setItem("token", response.token);
            localStorage.setItem("authenticated", true);

            this.loginMsg = "Welcome!";
            this.$router.push({ name: "switchboard" });
          } else {
            this.snackbar = true;
            this.loginMsg = response.data.error;
          }
        });
    }, //end of login method
  },
};
</script>
